import logo from 'shared/components/ShardError/logo.png';
import { Layout, Container } from './MaintenancePage.styles';

export function MaintenancePage() {
  const message =
    process.env.REACT_APP_MAINTENANCE_MESSAGE ||
    'We are currently performing scheduled maintenance. Please check back shortly.';

  return (
    <Layout>
      <Container>
        <img alt="SunCentral Logo" src={logo} title="SunCentral" width="230" />
        <h2>System Maintenance</h2>
        <p>{message}</p>
        <small>
          <a href="https://suncentral.net/support" target="_blank" rel="noreferrer">
            Need help? Contact us.
          </a>
        </small>
      </Container>
    </Layout>
  );
}
